import { LogLevelConfiguration, SettingGroup } from 'vrlcm-gui-types';
import { l10n } from '../../../i18n/i18nUtil';
import { ROUTES } from '../constants/RouteConstants';

const { SETTINGS } = ROUTES;

export const groups: SettingGroup[] = [
  {
    name: l10n('lcops.settings.systemAdministration'),
    actions: [
      {
        action: {
          route: `${SETTINGS}/system-details`
        },
        icon: 'host',
        name: l10n('lcops.settings.systemDetails')
      },
      {
        action: {
          route: `${SETTINGS}/logs`
        },
        icon: 'file-group',
        name: l10n('lcops.settings.logs')
      },
      {
        action: {
          route: `${SETTINGS}/patches`
        },
        icon: 'wrench',
        name: l10n('lcops.settings.systemPatches')
      },
      {
        action: {
          route: `${SETTINGS}/pspack`
        },
        icon: 'scroll',
        name: l10n('lcops.settings.pspack')
      },
      {
        action: {
          route: `${SETTINGS}/system-upgrade`
        },
        icon: 'backup-restore',
        name: l10n('lcops.settings.systemUpgrade')
      },
      {
        action: {
          route: `${SETTINGS}/time-settings`
        },
        icon: '/assets/images/time-settings.svg',
        name: l10n('lcops.settings.timeSettings')
      },
      {
        action: {
          route: `${SETTINGS}/change-password`
        },
        icon: 'key',
        name: l10n('lcops.settings.changePassword')
      },
      {
        action: {
          route: `${SETTINGS}/proxy`
        },
        icon: 'network-switch',
        name: l10n('lcops.settings.proxy')
      },
      {
        action: {
          route: `${SETTINGS}/change-certificate`
        },
        icon: 'certificate',
        name: l10n('lcops.settings.changeCertificate')
      },
      {
        action: {
          route: `${SETTINGS}/authentication-provider`
        },
        icon: 'users',
        name: l10n('lcops.settings.authenticationProvider')
      },
      {
        action: {
          route: `${SETTINGS}/outbound-notifications`
        },
        icon: 'bell',
        name: l10n('lcops.settings.outboundNotifications')
      },
      {
        action: {
          route: `${SETTINGS}/language-settings`
        },
        icon: 'language',
        name: l10n('lcops.settings.languageSettings')
      },
      {
        action: {
          route: `${SETTINGS}/system-settings`
        },
        icon: 'settings',
        name: l10n('lcops.settings.systemSettings')
      },
      {
        action: {
          route: `${SETTINGS}/load-balancer`
        },
        icon: 'cloud-traffic',
        name: l10n('lcops.settings.loadBalancer')
      },
      {
        action: {
          route: `${SETTINGS}/configure-lifecycle-minion`
        },
        icon: 'atom',
        name: l10n('lcops.settings.configureLifecycleMinion')
      }
    ]
  },
  {
    name: l10n('lcops.settings.serversAccounts'),
    actions: [
      {
        action: {
          route: `${SETTINGS}/ntp-servers`
        },
        icon: 'clock',
        name: l10n('lcops.settings.ntpServers')
      },
      {
        action: {
          route: `${SETTINGS}/snmp`
        },
        icon: 'nvme',
        name: l10n('lcops.settings.snmp')
      },
      {
        action: {
          route: `${SETTINGS}/dns`
        },
        icon: '/assets/images/DNS.svg',
        name: l10n('lcops.settings.dns')
      },
      {
        action: {
          route: `${SETTINGS}/my-vmware`
        },
        icon: 'user',
        name: l10n('lcops.settings.myVMware')
      },
      {
        action: {
          route: `${SETTINGS}/binary-mapping`
        },
        icon: 'folder',
        name: l10n('lcops.settings.binaryMapping')
      },
      {
        action: {
          route: `${SETTINGS}/smtp`
        },
        icon: 'envelope',
        name: l10n('lcops.settings.smtp')
      }
    ]
  }
];

export const logConfiguration: LogLevelConfiguration = {
  fileCount: '10',
  logLevel: 'info'
};
